// types
import { KeyboardEvent } from 'react';
import { PlanningEntityType } from 'generated/index';

export const getPlanningEntityTypeByFilterCommand = (
  event: KeyboardEvent<HTMLElement>
): PlanningEntityType | null | undefined | 'modifier' => {
  switch (event.key) {
    case 'e':
    case 'E':
    case 'm':
    case 'M':
      return 'EMPLOYEE';
    case 'p':
    case 'P':
      return 'CLIENT';
    case 'r':
    case 'R':
    case 'i':
    case 'I':
      return 'RESOURCE';
    case 'w':
    case 'W':
    case 'u':
    case 'U':
      return 'WORKPLACE';
    case 'a':
    case 'A':
      return null; // ALL
    case 'Shift': // Allow modifier keys for capital commands
      return 'modifier';
  }
};
